const TOKEN = "crm_embed_token";
const FLAG = "crm_embed";
const SLUG = "crm_embed_slug";

export const isEmbed = () => sessionStorage.getItem(FLAG) === "1";
export const embedToken = () => sessionStorage.getItem(TOKEN) || "";
export const embedSlug = () => sessionStorage.getItem(SLUG) || "";
export const startEmbed = (token, slug) => {
  sessionStorage.setItem(TOKEN, token);
  sessionStorage.setItem(FLAG, "1");
  if (slug) sessionStorage.setItem(SLUG, slug); else sessionStorage.removeItem(SLUG);
};
export const endEmbed = () => { sessionStorage.removeItem(TOKEN); sessionStorage.removeItem(FLAG); sessionStorage.removeItem(SLUG); };
export const inIframe = () => { try { return window.self !== window.top; } catch (e) { return true; } };

const TRUSTED_PARENTS = [/(^|\.)emergent\.sh$/, /(^|\.)emergentagent\.com$/, /(^|\.)emergentagent\.net$/, /^localhost$/];
const hostOf = (u) => { try { return new URL(u).hostname; } catch (e) { return ""; } };
export const trustedParent = () => {
  const origins = window.location.ancestorOrigins ? Array.from(window.location.ancestorOrigins) : [];
  const hosts = (origins.length ? origins : [document.referrer]).map(hostOf).filter(Boolean);
  return hosts.length > 0 && hosts.every((h) => TRUSTED_PARENTS.some((rx) => rx.test(h)));
};
